import { get } from 'lodash';

const selectCurrentNotice = (state) => {
  return get(state, 'notices');
};

export { selectCurrentNotice };
